webpackJsonp([6416834753913],{

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Example = __webpack_require__(33);
	
	var _Example2 = _interopRequireDefault(_Example);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Example2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'WebSockets: Example'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'There is a WebSockets example in the lore repo called ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/examples/websockets' },
	        'websockets'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This example allows you to create, edit and delete "todo" items and activity will be reflected across all browser tabs.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Video Walk-Through'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This will be added in the future.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-websockets-js-977b1aa6faca58f05245.js